(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["discount-percentage"] && !Shopify.designMode) return;
  try {
    class DiscountPercentage extends HTMLElement {
    connectedCallback() {
      this.eventTarget = this.closest('.shopify-section, dialog');
      this.eventTarget?.addEventListener('shopify:product:select', this.handleProductSelect);
    }

    disconnectedCallback() {
      this.eventTarget?.removeEventListener('shopify:product:select', this.handleProductSelect);
    }

    handleProductSelect = (event) => {
      if (!(event.target instanceof Element)) return;

      const productCard = this.closest('product-card');
      if (productCard && event.target.closest('product-card') !== productCard) return;

      event.promise
        .then(({ detail }) => {
          if (detail?.newProduct?.id) {
            this.dataset.productId = detail.newProduct.id;
          } else if (detail?.productId && detail.productId !== this.dataset.productId) {
            return;
          }

          const price = Number(detail?.resource?.price);
          const compareAtPrice = Number(detail?.resource?.compare_at_price);
          const discountPercentage =
            compareAtPrice > price && compareAtPrice > 0 ? Math.round(((compareAtPrice - price) * 100) / compareAtPrice) : 0;

          this.hidden = discountPercentage === 0;
          this.textContent = discountPercentage
            ? (this.dataset.labelTemplate ?? '').replace('__PERCENTAGE__', String(discountPercentage))
            : '';
        })
        .catch(() => {});
    };
  }

  if (!customElements.get('discount-percentage')) {
    customElements.define('discount-percentage', DiscountPercentage);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["topaz-rotating-text"] && !Shopify.designMode) return;
  try {
    class TopazRotatingText extends HTMLElement {
    #abortController;
    #index = 0;
    #intersectionObserver;
    #isVisible = false;
    #motionQuery;
    #mutationObserver;
    #timer;

    connectedCallback() {
      this.#abortController = new AbortController();
      const { signal } = this.#abortController;

      this.#motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.#motionQuery.addEventListener('change', this.#handleMotionChange, { signal });
      document.addEventListener('visibilitychange', this.#restart, { signal });

      if (this.dataset.designMode === 'true') {
        document.addEventListener('shopify:block:select', this.#handleBlockSelect, { signal });
      }

      this.#mutationObserver = new MutationObserver(this.#refresh);
      this.#mutationObserver.observe(this, { childList: true, characterData: true, subtree: true });

      this.#intersectionObserver = new IntersectionObserver(this.#handleIntersection);
      this.#intersectionObserver.observe(this);

      this.#refresh();
    }

    disconnectedCallback() {
      this.#abortController?.abort();
      this.#intersectionObserver?.disconnect();
      this.#mutationObserver?.disconnect();
      window.clearTimeout(this.#timer);
    }

    get #items() {
      return [...this.querySelectorAll('.topaz-rotating-text__item')].filter(
        (item) => item.dataset.empty !== 'true' && item.textContent?.trim()
      );
    }

    #refresh = () => {
      const items = this.#items;
      const activeItem = this.querySelector('.topaz-rotating-text__item.is-active');
      const activeIndex = items.indexOf(activeItem);

      if (activeIndex >= 0) {
        this.#index = activeIndex;
      } else if (this.#index >= items.length) {
        this.#index = 0;
      }

      this.toggleAttribute('data-ready', items.length > 0);
      this.#show(this.#index, false);
      this.#restart();
    };

    #show(index, animate) {
      const items = this.#items;

      if (items.length === 0) return;

      const currentItem = items.find((item) => item.classList.contains('is-active'));
      this.#index = (index + items.length) % items.length;
      const nextItem = items[this.#index];

      items.forEach((item) => {
        const isActive = item === nextItem;
        const isExiting = animate && item === currentItem && item !== nextItem;

        item.classList.toggle('is-active', isActive);
        item.classList.toggle('is-exiting', isExiting);
        item.setAttribute('aria-hidden', String(!isActive));
      });
    }

    #advance = () => {
      this.#show(this.#index + 1, true);
      this.#schedule();
    };

    #schedule() {
      window.clearTimeout(this.#timer);

      if (!this.#canPlay()) return;

      const interval = Number.parseInt(this.dataset.interval ?? '', 10) || 3000;
      this.#timer = window.setTimeout(this.#advance, interval);
    }

    #canPlay() {
      return (
        this.#items.length > 1 &&
        this.#isVisible &&
        document.visibilityState === 'visible' &&
        this.dataset.designMode !== 'true' &&
        !this.#motionQuery?.matches
      );
    }

    #restart = () => {
      this.#schedule();
    };

    #handleIntersection = (entries) => {
      this.#isVisible = Boolean(entries.at(-1)?.isIntersecting);
      this.#restart();
    };

    #handleMotionChange = () => {
      if (this.#motionQuery?.matches) {
        this.#show(0, false);
      }

      this.#restart();
    };

    #handleBlockSelect = (event) => {
      if (!(event.target instanceof Element)) return;

      const selectedItem = event.target.closest('.topaz-rotating-text__item');
      if (!selectedItem || selectedItem.closest('topaz-rotating-text') !== this) return;

      const selectedIndex = this.#items.indexOf(selectedItem);
      if (selectedIndex >= 0) this.#show(selectedIndex, false);
    };
  }

  if (!customElements.get('topaz-rotating-text')) {
    customElements.define('topaz-rotating-text', TopazRotatingText);
  }
  } catch(e) { console.error(e); }
})();

})();
